import { datadogLogs } from "@datadog/browser-logs";
import { getActiveServiceWorker } from "src/core/serviceWorker/getActiveServiceWorker";

export const preloadAssets = async (urls: string[]) => {
  try {
    const sw = await getActiveServiceWorker();

    sw.postMessage({
      type: "PRELOAD_ASSETS",
      urls,
    });
  } catch (error) {
    if (error instanceof Error) {
      datadogLogs.logger.warn(
        "[SW] Failed to send PRELOAD_ASSETS message",
        {},
        error
      );
    }
  }
};
